import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AvisoDeVencimiento } from '@/components/layout/AvisoDeVencimiento';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { MobileBottomNav } from './MobileBottomNav';
import {
  Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle,
} from '@/components/ui/sheet';
import { useUiStore } from '@/stores/ui.store';

export function AppShell() {
  const mobileDrawerOpen = useUiStore((s) => s.mobileDrawerOpen);
  const setMobileDrawer = useUiStore((s) => s.setMobileDrawer);
  const location = useLocation();

  // Auto-close drawer on route change so navigating doesn't leave it open.
  useEffect(() => {
    setMobileDrawer(false);
  }, [location.pathname, setMobileDrawer]);

  return (
    <div className="flex min-h-screen bg-background">
      {/* Desktop sidebar (lg+) */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Mobile/tablet drawer */}
      <Sheet open={mobileDrawerOpen} onOpenChange={setMobileDrawer}>
        <SheetContent side="left" className="w-[280px] p-0" hideCloseButton>
          <SheetHeader className="sr-only">
            <SheetTitle>Menú principal</SheetTitle>
            <SheetDescription>Navegación entre módulos.</SheetDescription>
          </SheetHeader>
          <Sidebar variant="bare" onNavigate={() => setMobileDrawer(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto pb-20 lg:pb-0">
          <div className="mx-auto w-full max-w-[1600px] px-4 py-4 sm:px-6 sm:py-6">
            {/* Va aquí y no en la pantalla de suscripción: quien entra ahí ya
                sabe que debe pagar. Hay que alcanzar a quien no entra nunca. */}
            <AvisoDeVencimiento />
            <Outlet />
          </div>
        </main>
      </div>

      <MobileBottomNav />
    </div>
  );
}
